import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import breakPoints from "../app/BreakPoints";
import GradientButton from "../common/GradientButton";
import useVenueId from "../common/useVenueId";

interface Props {
  sessionId: number;
}

const SessionRowActions = ({ sessionId }: Props) => {
  const venueId = useVenueId();

  const linkTo = useMemo(
    () => ({ pathname: `/${venueId}/session/${sessionId}` }),
    [venueId, sessionId],
  );

  return (
    <div>
      <Link replace to={linkTo}>
        <GradientButton> View Session </GradientButton>
      </Link>
      <style jsx>{`
        div {
          display: flex;
        }
        div > :global(a) {
          margin: 0 5% 0 0;
          text-decoration: none;
        }
        .calendarImage {
          height: 40px;
        }
        @media only screen and (max-width: ${breakPoints.small}px) {
          div > :global(a) {
            display: flex;
            flex-grow: 1;
            align-items: center;
          }
          div :global(button) {
            display: flex;
            flex-grow: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SessionRowActions;
